import lrAIChatList from './_src/lrAIChatList.vue'

lrAIChatList.install = function(Vue) {
  Vue.component(lrAIChatList.name, lrAIChatList)
}

export default lrAIChatList